var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ArticleCarousel, ArticleCompactInlineCard, ErrorBoundary } from '@browsing/components';
import { Translate, TranslateScope } from '@pegasus/translation';
import InView from 'react-intersection-observer';
import { trackSelectItem, trackViewItemList } from '@browsing/tracking';
import { CatalogType, isModifierKeyPressed, NavigationSourceType } from '@browsing/utils';
import { useNavigateToPDP } from '@browsing/hooks';
import { useBiggestDiscount } from './use-biggest-discount';
var BiggestDiscountCarouselInternal = function (props) {
    var profileFashionPreference = props.profileFashionPreference, selectedFashionPreference = props.selectedFashionPreference, textTitle = props.textTitle, navigateToPDPInCurrentTab = props.navigateToPDPInCurrentTab;
    var _a = useNavigateToPDP({ navigateToPDPInCurrentTab: navigateToPDPInCurrentTab }), navigateToPDP = _a.navigateToPDP, getPDPURLPath = _a.getPDPURLPath;
    var carouselArticles = useBiggestDiscount({
        profileFashionPreference: profileFashionPreference,
        selectedFashionPreference: selectedFashionPreference,
    })[0];
    var onInView = function (inView) {
        if (inView && carouselArticles.length > 0) {
            trackViewItemList({
                items: carouselArticles,
                element: 'best_deal_carousel',
                context: 'best_deal_carousel',
                itemListName: 'best_deal_carousel',
            });
        }
    };
    var onArticleClick = function (article, index) { return function (e) {
        trackSelectItem({
            element: 'best_deal_carousel',
            itemListName: 'best_deal_carousel',
            context: 'best_deal_carousel',
            item: article,
        }, {
            customMapper: function () { return ({ index: index }); },
        });
        // Prevent clicks on LUX <ArticleCard/>, whose children are wrapped in a link, from navigating to the PDP.
        e.preventDefault();
        navigateToPDP({
            queryParams: {
                campaignId: article.campaignIdentifier,
                configSku: article.sku,
                navigationSource: NavigationSourceType.BiggestDiscount,
                catalogType: CatalogType.BiggestDiscount,
            },
            shouldOpenInNewTab: isModifierKeyPressed(e),
        });
    }; };
    // Pass `pdpURLPath` to <ArticleCard/>'s link for accessibility/robustness, even though we prevent its
    // default behavior. e.g. the user might right-click the link, which is not handled here.
    var getArticleURLPath = function (article) {
        return getPDPURLPath({
            queryParams: {
                campaignId: article.campaignIdentifier,
                configSku: article.sku,
                navigationSource: NavigationSourceType.BiggestDiscount,
                catalogType: CatalogType.BiggestDiscount,
            },
        });
    };
    if (!carouselArticles || carouselArticles.length <= 0)
        return null;
    return (React.createElement(InView, { as: "div", onChange: onInView, triggerOnce: true, "data-testid": "biggest-discount-carousel" },
        React.createElement(TranslateScope, { path: "article" },
            React.createElement(ArticleCarousel, { isOverflowCarousel: true, id: "best-deals-headline", title: React.createElement(TranslateScope, null,
                    React.createElement(Translate, { message: "bestDeals.carouselTitle" })), textTitle: textTitle }, carouselArticles.map(function (article, index) { return (React.createElement(ArticleCompactInlineCard, { key: index, brand: article.brand, onClick: onArticleClick(article, index), media: article.media, nameCategoryTag: article.nameCategoryTag, nameColor: article.nameColor, nameShop: article.nameShop, price: article.price, specialPrice: article.specialPrice, pdpURLPath: getArticleURLPath(article) })); })))));
};
export var BiggestDiscountCarousel = function (props) { return (React.createElement(ErrorBoundary, { componentName: "BiggestDiscountCarousel" },
    React.createElement(BiggestDiscountCarouselInternal, __assign({}, props)))); };
